import { render, staticRenderFns } from "./OtherPartnersTable.vue?vue&type=template&id=3aa86e43&"
import script from "./OtherPartnersTable.vue?vue&type=script&lang=js&"
export * from "./OtherPartnersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/OtherPartnersTable.vue
// module id = null
// module chunks = 